import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Dispatch extends OBase {
  update () {
    let lInputTree = this.getObjectInput('List');
    let dInputTree = this.getObjectInput('Dispatch pattern');

    let aOutput = this.outputs['List A'].paramObject;
    let bOutput = this.outputs['List B'].paramObject;

    let outTreeA = new Geometry.DataTree();
    let outTreeB = new Geometry.DataTree();

    let dataTrees = [lInputTree, dInputTree];
    let outDataTrees = [];

    Geometry.makeMultipleBranches(dataTrees, outDataTrees);

    lInputTree = outDataTrees[0];
    dInputTree = outDataTrees[1];

    for (let i = 0; i < lInputTree.branches.length; i++) {
      let patternList = dInputTree.branches[Math.min(i, dInputTree.branches.length - 1)];
      let path = new Geometry.GHPath(lInputTree.paths[i]);
      outTreeB.addEmpty(path);
      outTreeA.addEmpty(path);

      patternList = patternList.map(pat => {
        if ((typeof pat) === 'string') {
          return pat.trim();
        }
        return pat;
      });

      for (let j = 0; j < lInputTree.branches[i].length; j++) {
        let pattern = patternList[j % patternList.length];
        if ((pattern === 0) || (pattern === false) || (pattern === 'False') || (pattern === 'false')) {
          outTreeB.add(lInputTree.branches[i][j], path);
        } else {
          outTreeA.add(lInputTree.branches[i][j], path);
        }
      }
    }

    aOutput.value = outTreeA;
    bOutput.value = outTreeB;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Dispatch.js